
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, InventoryConfiguration_$reflection, RequestedValue$1_$reflection, CustomerConfiguration_$reflection } from "../../../Shared/Shared.js";
import { union_type, class_type, option_type, int32_type, bool_type, record_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class State extends Record {
    constructor(CustomerConfiguration, InventoryConfiguration, FormState) {
        super();
        this.CustomerConfiguration = CustomerConfiguration;
        this.InventoryConfiguration = InventoryConfiguration;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.Inventory.Types.State", [], State, () => [["CustomerConfiguration", RequestedValue$1_$reflection(CustomerConfiguration_$reflection())], ["InventoryConfiguration", RequestedValue$1_$reflection(InventoryConfiguration_$reflection())], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetInventoryNumberIsUnique", "SetInventoryNumberAutomaticIncrease", "SetAllowQRCodeAssignmentMultipleTimes", "SetBookingHistoryRetentionYears", "SetPlannedReturnDateMandatory", "SetCompletenessCheckOnSetReturnRequired", "SetCompletenessCheckOnSetReturnScanOnly", "CustomerConfigurationFetched", "UpdateCustomerConfiguration", "CustomerConfigurationUpdated", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Inventory.Types.Msg", [], Msg, () => [[["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", option_type(int32_type)]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", CustomerConfiguration_$reflection()]], [], [["Item", ClientApiResponse$1_$reflection(CustomerConfiguration_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

